import React from 'react';
import Button from './Button';
import type { AlternativeMethodCallbacks } from '../../types/verification';

type TryAnotherWayProps = AlternativeMethodCallbacks & {
  show: boolean;
};

export default function TryAnotherWay({
  show,
  onChooseSms,
  onChooseKba,
  onChooseProspect,
}: TryAnotherWayProps) {
  const hasAnyOption = onChooseSms ?? onChooseKba ?? onChooseProspect;
  if (!show || !hasAnyOption) return null;

  return (
    <div className="space-y-3 pt-2">
      <p className="text-center text-sm text-gray-600 font-medium">
        Try a different verification method:
      </p>
      {onChooseSms && (
        <Button
          id="alt-method-choose-sms"
          name="alt-method-choose-sms"
          type="button"
          onClick={onChooseSms}
          variant="outline"
          fullWidth
        >
          Verify with SMS Code
        </Button>
      )}
      {onChooseKba && (
        <Button
          id="alt-method-choose-kba"
          name="alt-method-choose-kba"
          type="button"
          onClick={onChooseKba}
          variant="outline"
          fullWidth
        >
          Verify with Security Questions
        </Button>
      )}
      {onChooseProspect && (
        <Button
          id="alt-method-choose-prospect"
          name="alt-method-choose-prospect"
          type="button"
          onClick={onChooseProspect}
          variant="outline"
          fullWidth
        >
          Verify with Offer Code
        </Button>
      )}
    </div>
  );
}
